import styled from "styled-components";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import IconWrapper from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";

export const Button = styled.a`
    display: flex;
    align-items: center;
    column-gap: ${theme.space[1]}px;
    padding: ${theme.space[2]}px;
    border: 1px solid ${theme.colors.platinumMedium};
    border-radius: 4px;

    ${IconWrapper} {
        display: flex;
        align-items: center;
    }

    /* stylelint-disable */
    ${IconWrapper}:nth-of-type(2) {
        margin-left: auto;
    }
    /* stylelint-enable */

    &:is(:hover, :focus) {
        background-color: ${theme.colors.platinumMedium};
    }

    html[dir="rtl"] & {
        ${IconWrapper}:nth-of-type(2) {
            margin-left: 0;
            margin-right: auto;
        }
    }
`;

export const ButtonTitle = styled.div`
    position: relative;
    top: 2px; /* Fix alignment of text in button */
    font-family: ${theme.fonts.regular};
    font-size: 1.4rem;
    letter-spacing: 0.2rem;
    line-height: 2rem;
    text-transform: uppercase;
`;

export const ButtonContent = styled.div`
    display: flex;
    flex-direction: column;
    &,
    li {
        font-family: ${theme.fonts.book};
        font-size: 1.6rem;
        letter-spacing: 0.1rem;
        line-height: 2rem;
    }
`;

export const FinanceDisclaimerContent = styled.div`
    display: flex;
    align-items: flex-start;
    margin-top: ${theme.space[1] / 2}px;
`;
